import i18n from "@/localization/localization";
const $t = (key, params) => i18n.global.t(key, params);
export function investmentFormCheckboxes(type, projectId, projectName) {
    const host = process.env.VUE_APP_HOST_API[process.env.VUE_APP_HOST_API.length - 1] === "/"
        ? process.env.VUE_APP_HOST_API
        : `${process.env.VUE_APP_HOST_API}/`;
    if (type == "rwaTown") {
        return [
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: "Terms of Use",
                url: "/terms-of-use"
            },
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: "Risk Disclosure Statement",
                url: "/risk-disclosure"
            },
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: $t("auCapitals.capitalModal.2step.agreePolicyLink", {}),
                name: "Privacy Policy",
                link: `${host}api/aut/documents/privacy`
            }
        ];
    }
    const config = [
        {
            text: $t("auCapitals.capitalModal.2step.toThe", {}),
            linkText: $t("auCapitals.capitalModal.2step.memorandumAgreeLink", {}),
            name: projectName + " memorandum",
            link: `${host}api/aut/documents/memorandum/` + projectId
        },
        {
            text: $t("auCapitals.capitalModal.2step.toThe", {}),
            linkText: $t("auCapitals.capitalModal.2step.agreePolicyLink", {}),
            name: "Privacy Policy",
            link: `${host}api/aut/documents/privacy`
        }
    ];
    if (type == "autentic") {
        const autConfig = [
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: $t("auCapitals.capitalModal.2step.agreeHoldersLink", {}),
                name: "Autentic Ltd and Token Holders Agreement",
                link: `${host}api/aut/documents/agreement`
            },
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: $t("auCapitals.capitalModal.2step.agreeAirdropLink", {}),
                name: "Property Token Airdrop Terms",
                link: `${host}api/aut/documents/airdrop`
            },
            {
                text: $t("auCapitals.capitalModal.2step.toThe", {}),
                linkText: $t("auCapitals.capitalModal.2step.agreeGovernanceLink", {}),
                name: "DAO Governance and Voting Policy",
                link: `${host}api/aut/documents/dao`
            }
        ];
        config.push(...autConfig);
    }
    return config;
}
